<template>
  <!-- 行业资质  -->
  <div>
    <!--删除列表时使用的是rowKey的id-->
     <a-modal
      title="查看"
      :visible="visible"
      @ok="closeFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      :footer="null"
    >
    <p>类目：{{row.category1Name}}>{{row.category2Name}}>{{row.category3Name}}</p>
    <x-tabula
      ref="table"
      rowKey="contractYear"
      :dataSource="dataSource"
      :columns="columns"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :paginationParam="false"
    >
    </x-tabula>
     </a-modal>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      row: undefined,
      visible: false,
      columns: [
        {
          title: '行业资质',
          dataIndex: 'title',
          align: '',
          width: '200'
        },
        {
          title: '类型',
          dataIndex: 'statusDesc',
          align: '',
          width: '200'
        }
      ],
      dataSource: [],
      searchParams: {
        contractYear: undefined
      },

      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }

    };
  },

  created () {
  },
  methods: {
    show (obj) {
      this.row = obj;
      this.$get({
        url: '/local/qualify/' + obj.qualifyId,
        params: { }
      }).then((res) => {
        this.dataSource = res.data;
        this.visible = true;
      });
    },
    closeFun () {
      this.visible = false;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
</style>
